import React from 'react';
import PropTypes from 'prop-types';
import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';
import { productLinks } from 'settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const StoreButtons = (props) => {
  const { title } = props;
  return (
    <React.Fragment>
      {title && <h3>Get the app on your mobile device</h3>}
      <div className="storeButtons__container">
          <a href={productLinks.ios} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={['fab', 'app-store']} />
          </a>
          <a href={productLinks.android} target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={['fab', 'google-play']} />
          </a>
      </div>
    </React.Fragment>
  );
};

export default StoreButtons;

StoreButtons.propTypes = {
  title: PropTypes.bool,
};

StoreButtons.defaultProps = {
  title: false,
};
